import { createCell, getRandom, random } from 'helpers';
import * as setup from 'setup';
import Entity from '../Entity';

export default class Nature extends Entity {

    props: EntityBaseProps & NatureProps;

    constructor(gameState: GameState, type?: NatureType, props?: EntityBaseProps & NatureProps, state?: any) {
        // Get type
        if (!type) {
            const types: NatureType[] = ['leaf1', 'leaf2', 'leaf3', 'leaf4', 'stone1', 'stone2', 'stone3', 'stone4'];
            type = getRandom(types);
        }

        // Get props
        props = {
            idleTexture: type.toLowerCase().includes('blocker') ? undefined : `nature/nature-${type}.png`,
            x: random(0, setup.map.cells.wide - 1, true),
            y: random(0, setup.map.cells.wide - 1, true),
            ...props,
        };

        // Call super
        super(gameState, 'nature', type, {}, props, state);

        // Initialize
        this.props = props;
        this.zIndex = props.zIndex || 1;
    }

    init = () => {
        if (this.type === 'antColony') {
            this.playSound('nature-antColony', 0.2, true);
        }
    }

    getClosestFogCell = () => {
        const { fog } = this.gameState;
        
        // Start from center and expand outwards
        const maxDistance = this.getMaxCarryDistance() - 1;
        for (let range = 1; range < setup.map.cells.wide / 2; range++) {
            for (let x = this.cell.x - range; x <= this.cell.x + range; x++) {
                for (let y = this.cell.y - range; y <= this.cell.y + range; y++) {
                    // Check fog
                    const cellName = `${x},${y}`;
                    if (!fog[cellName]) {
                        continue;
                    }

                    // Check distance
                    const cell = createCell(x, y);
                    if (this.getDistanceTo(cell) <= maxDistance) {
                        return cell;
                    }
                }
            }
        }

        return null;
    }

    getFoodsInRange = () => {
        const maxDistance = this.getMaxCarryDistance();
        return this.getTargetsInRange(this.gameState.entities.foods.active, maxDistance);
    }

    getMaxCarryDistance = () => {
        const { carry, speed } = this.gameState.entities.ants.buffs;
        const carryCapacity = (setup.ants.worker.carryCapacity || 0) * (carry + 1);
        const movingSpeed = (setup.ants.worker.movingSpeed || 1) * (speed + 1);
        return (carryCapacity / 2 * movingSpeed / (setup.ants.worker.turnCalories || 1) - 1) * 0.75;
    }

    getDebugRadius = () => {
        if (this.type === 'antColony') {
            return this.getMaxCarryDistance();
        }
        return null;
    }

}